import { conceptoToTotales } from '../../../utils/calculate.conceptos';
import { numeroALetras } from '../../../utils/numeroLetra';

export type ConceptoTotales = ReturnType<typeof conceptoToTotales>;

export const totalEnLetra = (value: number) => numeroALetras(value, {
    plural: 'pesos mexicanos',
    singular: 'pesos mexicanos',
    centPlural: 'centavos',
    centSingular: 'centavo'
}).toLowerCase();
